/* eslint-disable no-unused-vars */
// config/firebaseConfig.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Check for empty values
const missingValues = Object.entries(firebaseConfig)
  .filter(([key, value]) => !value)
  .map(([key]) => key);

if (missingValues.length > 0) {
  console.error("Missing Firebase config values:", missingValues);
}

// Initialize Firebase app
let app;
try {
  if (!getApps().length) {
    app = initializeApp(firebaseConfig);
    // console.log("Firebase app initialized successfully");
  } else {
    app = getApp();
    // console.log("Using existing Firebase app");
  }
} catch (error) {
  console.error("Error initializing Firebase app:", error);
  // console.log("Attempting fallback initialization...");
  const fallbackConfig = {
    apiKey: "test-key",
    authDomain: "test.firebaseapp.com",
    projectId: "test-project",
    storageBucket: "test.appspot.com",
    messagingSenderId: "1234567890",
    appId: "1:1234567890:web:test",
  };
  app = initializeApp(fallbackConfig, "FallbackApp");
}

// Don't initialize messaging here - it needs to be async
let messagingInstance = null;

// Async function to get messaging instance
export const getMessagingInstance = async () => {
  if (messagingInstance) {
    // console.log("[Firebase] Returning cached messaging instance");
    return messagingInstance;
  }

  try {
    // console.log("[Firebase] Checking FCM support...");

    // Check if FCM is supported in this environment
    const supported = await isSupported();
    // console.log("[Firebase] FCM supported:", supported);

    if (supported) {
      if (!app) {
        throw new Error("Firebase app not initialized");
      }

      messagingInstance = getMessaging(app);
      // console.log("[Firebase] Messaging initialized successfully");
    } else {
      console.warn("[Firebase] Messaging not supported in this environment");
    }
  } catch (error) {
    console.error("[Firebase] Error initializing messaging:", error);

    // More detailed error logging
    if (error.code) {
      console.error("[Firebase] Error code:", error.code);
    }
    if (error.message) {
      console.error("[Firebase] Error message:", error.message);
    }
  }

  return messagingInstance;
};

export { app };
